import React, { useState } from 'react';

export interface SectionConfig {
  key: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: React.ComponentType<any>;
  props?: Record<string, unknown>;
}

export function usePanelSections(sections: SectionConfig[]) {
  // State for collapsible sections in panel mode
  const [expandedSections, setExpandedSections] = useState<Record<string, boolean>>(() =>
    sections.reduce((acc, section) => ({
      ...acc,
      [section.key]: true // All sections start expanded
    }), {})
  );

  const toggleSection = (sectionKey: string) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionKey]: !prev[sectionKey]
    }));
  };

  const renderSections = (isDetailView: boolean = false) => {
    return sections.map(({ key, component: Component, props: sectionProps = {} }) => {
      const props: Record<string, unknown> = {
        ...sectionProps,
        isDetailView,
        isExpanded: isDetailView ? true : expandedSections[key], // Always expanded in detail view, collapsible in panel
        onToggle: isDetailView ? undefined : () => toggleSection(key)
      };

      return React.createElement(Component, { key, ...props });
    });
  };

  return {
    expandedSections,
    toggleSection,
    renderSections
  };
}